<template>
  <v-dialog v-model="isOpen" max-width="450" persistent scrollable>
    <v-card class="pending-folder-modal" v-if="isOpen">
      <v-card-title class="headline">
        <span>Add Account</span>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="isOpen = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
      <div class="pending-folder-modal__loading" v-if="isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <component :is="currentView"
        :provider="folder.provider"
        :featured-service-types="featuredServiceTypes"
        :folder="folder"
        :selected-service-types.sync="selectedServiceTypes"
        v-else
      />
      </v-card-text>
      <template v-if="!serviceTypeAnswered">
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            @click.prevent.stop="addServiceTypesToFolder"
            :disabled="selectedServiceTypes.length == 0"
            v-if="isOpen && !loading && !folder.service_types.length"
          >
            Add This Account
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import ServiceTypeGroups from './ServiceTypeGroups'
  import MultipleAccounts from './MultipleAccounts'
  import airbrake from '@/helpers/airbrake'

  export default {
    data () {
      return {
        selectedServiceTypes: [],
        folderLoading: false,
        providerName: null
      }
    },
    watch: {
      pending () {
        if (!this.pending) {
          this.selectedServiceTypes = []
        }
      }
    },
    computed: {
      ...mapState('folders', ['pending']),
      ...mapState('serviceTypes', ['allServiceTypes', 'loading']),
      isLoading () {
        return this.loading || this.folderLoading
      },
      isOpen: {
        get () {
          if (this.pending) {
            // Set the current provider name
            this.providerName = this.pending.provider.name
          }
          return !!this.pending
        },
        set (val) {
          if (!val) {
            this.cancelFolder()
          }
        }
      },
      currentView () {
        return this.serviceTypeAnswered ? MultipleAccounts : ServiceTypeGroups
      },
      serviceTypeAnswered () {
        return this.folder && this.folder.service_types.length
      },
      folder () {
        return this.pending
      },
      featuredServiceTypes () {
        return (this.folder && this.folder.provider.service_types) || []
      }
    },
    methods: {
      cancelFolder () {
        this.$store.dispatch('folders/cancelPendingFolder')
      },
      addServiceTypesToFolder () {
        const newFolder = Object.assign(this.folder, {service_types: this.selectedServiceTypes})
        this.folderLoading = true
        this.$store.dispatch('folders/createFolder', newFolder)
          .then(() => {
            this.folderLoading = false
          })
          .catch(err => {
            this.folderLoading = false
            airbrake.notify(err)
          })
      }
    }
  }
</script>

<style lang="stylus">
  .pending-folder-dialog__loading
    height: 350px
    display: flex
    align-items: center
    justify-content: center
</style>




// WEBPACK FOOTER //
// frontend/src/components/common/PendingFolderDialog.vue